import { render, staticRenderFns } from "./CampaignWithFilter.vue?vue&type=template&id=4a882bea&scoped=true&"
import script from "./CampaignWithFilter.vue?vue&type=script&lang=js&"
export * from "./CampaignWithFilter.vue?vue&type=script&lang=js&"
import style0 from "./CampaignWithFilter.vue?vue&type=style&index=0&id=4a882bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a882bea",
  null
  
)

export default component.exports